import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export const CodeSlot = ({ position }) => {
  const { pathname } = useLocation();
  const [blocks, setBlocks] = useState([]);
  useEffect(() => {
    api.get("/code-blocks/active", { params: { path: pathname } }).then((r) => setBlocks(r.data.filter((b) => b.position === position))).catch(() => setBlocks([]));
  }, [pathname, position]);
  if (!blocks.length) return null;
  return blocks.map((b) => b.kind === "html" ? (
    <div key={b.id} className={`lg-code-${b.id}`} data-testid={`code-block-${b.id}`}>
      <style>{b.css}</style>
      <div dangerouslySetInnerHTML={{ __html: b.html }} />
    </div>
  ) : (
    <iframe key={b.id} title="Contenido especial" sandbox="allow-scripts" srcDoc={b.srcdoc} height={b.height} loading="lazy" referrerPolicy="no-referrer"
      className="block w-full border-0" data-testid={`code-block-${b.id}`} />
  ));
};
